/*
 * @Author: Merlin
 * @Date: 2024-02-27 18:48:26
 * @LastEditors: Merlin
 * @LastEditTime: 2024-02-27 18:48:47
 * @Description: 
 */

// ▼用于游戏 
export const oMinesGame = {
    'AutoPick': {
        en: 'Auto Pick', 
        cn: '自动抽选',
    },
    'MinesAmount': {
        en: 'Mines Amount', 
        cn: '地雷数量',
    },
    // ↓游戏说明-------------------------------------------------
    'ruleDesc01': {
        en: 'Select the number of mines and place your bets, click on the mines one by one, the more mines you avoid, the better your odds.',
        cn: '选择地雷数量并下注，逐一点击排雷，避开地雷越多，赔率越高。',
    },
    // ↓ Mini 版中被废弃 
    'ruleDesc02': { en: '', cn: '', },
    'ruleDesc03': { en: '', cn: '', },
    'ruleDesc04': { en: '', cn: '', },
};



